module.exports = __webpack_public_path__ + "img/User.f8d05d74.svg";